import { render } from "./CreateWorkflowScreen.vue?vue&type=template&id=7e96081a"
import script from "./CreateWorkflowScreen.vue?vue&type=script&lang=ts"
export * from "./CreateWorkflowScreen.vue?vue&type=script&lang=ts"
script.render = render

export default script